"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Title_1 = require("./Title");
exports.Title = Title_1.default;
var titleOptions_1 = require("./titleOptions");
exports.titleOptions = titleOptions_1.default;
//# sourceMappingURL=index.js.map